"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyButtonContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _useCopy = require("b2b-components/hooks/useCopy");
var _useIsomorphicLayoutEffect = require("b2b-components/hooks/useIsomorphicLayoutEffect");
var _useTooltip = require("b2b-components/hooks/useTooltip");
var _device = require("b2b-components/utils/device");
var _CopyButton = require("./CopyButton");
const CopyButtonContainer = _ref => {
  let {
    value,
    deviceType,
    getTooltipText,
    isTooltipEnabled,
    ...restProps
  } = _ref;
  const [copyStatus, onCopy, resetCopyStatus] = (0, _useCopy.useCopy)({
    value
  });
  const {
    isTooltipVisible,
    tooltipPosition,
    onMouseEnter,
    onMouseLeave,
    tooltipAnchorRef,
    tooltipRef,
    updateTooltipPosition
  } = (0, _useTooltip.useTooltip)();
  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(() => {
    updateTooltipPosition();
  }, [copyStatus, isTooltipEnabled, isTooltipVisible]);
  const handleCopy = event => {
    event.stopPropagation();
    onCopy();
  };
  const handleMouseLeave = event => {
    onMouseLeave(event);
    resetCopyStatus();
  };
  return /*#__PURE__*/_react.default.createElement(_CopyButton.CopyButton, (0, _extends2.default)({}, restProps, {
    isTooltipEnabled: isTooltipEnabled,
    isTooltipVisible: !(0, _device.isDesktop)(deviceType) ? !!copyStatus : isTooltipVisible,
    tooltipPosition: tooltipPosition,
    onMouseEnter: onMouseEnter,
    onMouseLeave: handleMouseLeave,
    tooltipAnchorRef: tooltipAnchorRef,
    tooltipRef: tooltipRef,
    onCopy: handleCopy,
    tooltipText: getTooltipText(copyStatus)
  }));
};
exports.CopyButtonContainer = CopyButtonContainer;
//# sourceMappingURL=CopyButtonContainer.js.map